import { render, staticRenderFns } from "./ProductItemList.vue?vue&type=template&id=384c2ee4&scoped=true"
import script from "./ProductItemList.vue?vue&type=script&lang=js"
export * from "./ProductItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c2ee4",
  null
  
)

export default component.exports